import ENV from '../config/env'

// Resolve a relative media URL (e.g. /uploads/profile_photos/foo.jpg)
// to an absolute URL against the configured backend. Pass-through for
// absolute URLs.
//
// #tree-avatar-diag (today): treat whitespace-only strings as "no
// photo" so a single space or a tab in the DB doesn't slip through
// the `!url` guard and produce a URL that 404s — the broken-image
// glyph some browsers paint for SVG <image href=...> when the load
// fails is what produced the "generic landscape image" on Ramesh
// Sharma and Priya Sharma's tree nodes. Empty / null / whitespace
// all now return null so callers fall back to their initials/avatar
// rendering branch.
export function resolveMediaUrl(url: string | null | undefined): string | null {
  if (!url || !url.trim()) return null
  if (url.startsWith('http://') || url.startsWith('https://')) return url
  return `${ENV.API_URL}${url.startsWith('/') ? '' : '/'}${url}`
}
